import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface PlanLimitsProps {
  maxRecipes: number;
  maxIngredients: number;
  maxMaterials: number;
  unlimitedRecipes: boolean;
  unlimitedIngredients: boolean;
  unlimitedMaterials: boolean;
  onChange: (field: string, value: number | boolean) => void;
}

export function PlanLimits({
  maxRecipes,
  maxIngredients,
  maxMaterials,
  unlimitedRecipes,
  unlimitedIngredients,
  unlimitedMaterials,
  onChange,
}: PlanLimitsProps) {
  return (
    <div>
      <Label className="text-base font-semibold mb-3 block">Usage Limits</Label>
      <div className="space-y-3 p-4 border rounded-lg">
        {/* Recipes Limit */}
        <div className="flex items-center gap-3">
          <div className="flex-1">
            <Label htmlFor="maxRecipes">Max Recipes</Label>
            <Input
              id="maxRecipes"
              type="number"
              min="0"
              value={maxRecipes}
              onChange={(e) => onChange('maxRecipes', parseInt(e.target.value) || 0)}
              disabled={unlimitedRecipes}
              placeholder="0"
            />
          </div>
          <div className="flex items-center gap-2 pt-6">
            <input
              type="checkbox"
              id="unlimitedRecipes"
              checked={unlimitedRecipes}
              onChange={(e) => onChange('unlimitedRecipes', e.target.checked)}
              className="h-4 w-4 rounded border-gray-300"
            />
            <Label htmlFor="unlimitedRecipes" className="cursor-pointer">Unlimited</Label>
          </div>
        </div>

        {/* Ingredients Limit */}
        <div className="flex items-center gap-3">
          <div className="flex-1">
            <Label htmlFor="maxIngredients">Max Ingredients</Label>
            <Input
              id="maxIngredients"
              type="number"
              min="0"
              value={maxIngredients}
              onChange={(e) => onChange('maxIngredients', parseInt(e.target.value) || 0)}
              disabled={unlimitedIngredients}
              placeholder="0"
            />
          </div>
          <div className="flex items-center gap-2 pt-6">
            <input
              type="checkbox"
              id="unlimitedIngredients"
              checked={unlimitedIngredients}
              onChange={(e) => onChange('unlimitedIngredients', e.target.checked)}
              className="h-4 w-4 rounded border-gray-300"
            />
            <Label htmlFor="unlimitedIngredients" className="cursor-pointer">Unlimited</Label>
          </div>
        </div>

        {/* Materials Limit */}
        <div className="flex items-center gap-3">
          <div className="flex-1">
            <Label htmlFor="maxMaterials">Max Materials & Equipment</Label>
            <Input
              id="maxMaterials"
              type="number"
              min="0"
              value={maxMaterials}
              onChange={(e) => onChange('maxMaterials', parseInt(e.target.value) || 0)}
              disabled={unlimitedMaterials}
              placeholder="0"
            />
          </div>
          <div className="flex items-center gap-2 pt-6">
            <input
              type="checkbox"
              id="unlimitedMaterials"
              checked={unlimitedMaterials}
              onChange={(e) => onChange('unlimitedMaterials', e.target.checked)}
              className="h-4 w-4 rounded border-gray-300"
            />
            <Label htmlFor="unlimitedMaterials" className="cursor-pointer">Unlimited</Label>
          </div>
        </div>
      </div>
    </div>
  );
}
